<template>
  <div class="sticky z-10 top-0 w-full bg-white">
    <div class="w-full h-2 bg-core bg-opacity-16">
      <div
        class="h-full bg-core transition-all duration-500 ease-out"
        :style="{ width: `${percentage}%` }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
  @Prop({ type: Number, required: true })
  percentage!: number;
}
</script>
